export default () => ({
  component: 'transactions-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
